import React, { useMemo } from "react";

import _ from "lodash";
import { TagsIcon } from "lucide-react";

import { MultiSelect } from "@/components/fields/multi-select";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { useTags } from "@/contexts/tags-context";
import { useEventRepository } from "@/pages/events/hooks/use-event-repository";

export function ClearTagModal() {
  const [isOpen, setIsOpen] = React.useState(false);
  const [tagToRemove, setTagToRemove] = React.useState<string>();

  const { clearTag } = useEventRepository();
  const { tags } = useTags();

  const handleClose = async () => {
    setIsOpen(false);
  };

  const handleSubmit = async () => {
    await clearTag(tagToRemove!);
    handleClose();
  };

  const canSubmit = useMemo(() => {
    const tagNotEmpty = !_.isEmpty(tagToRemove);
    return tagNotEmpty;
  }, []);

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && setIsOpen(false)}>
      <DialogTrigger asChild>
        <Button
          variant="outline"
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <TagsIcon />
          Clear Tag
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>Clear Tag from all events</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          The tag you'll select will be deleted from <b>ALL</b> the events that
          it's applied
        </DialogDescription>

        <div className="space-y-4 py-4">
          <MultiSelect
            options={tags}
            selected={tags.map((t) => t.value)}
            onChange={(v) => {
              const newSelectedItems = new Set(v);
              // 2. Filter the main array
              setTagToRemove(
                tags.filter((item) => !newSelectedItems.has(item.value))[0]
                  .value,
              );
              // setTags(v);
            }}
            placeholder="Select or type tags..."
          />
          {tagToRemove && (
            <div className="flex flex-row gap-2 items-center">
              <Label>Tag to clean:</Label>
              <Badge>{tagToRemove}</Badge>
            </div>
          )}
        </div>

        <DialogFooter className="flex gap-2">
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={canSubmit}>
            Submit
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
